export default __webpack_public_path__ + "static/placeholder-a13a26c0a8ecf81370f8d27f882ed0ca.svg";